import {Injectable} from '@angular/core';

declare var webkitSpeechRecognition: any;

@Injectable({
  providedIn: 'root',
})
export class VoiceRecognitionService {
  speechRecognition: any;
  isStarted = false;
  isStoppedAutomatically = true;
  onSpeechDetected: any;

  constructor() {
  }

  init() {
    if ("webkitSpeechRecognition" in window) {
      this.speechRecognition = new webkitSpeechRecognition();
      this.speechRecognition.continuous = false;
      this.speechRecognition.interimResults = true;
      this.speechRecognition.lang = 'fa-IR';
      this.speechRecognition.addEventListener('result', (event: any) => {
        let text = Array.from(event.results)
          .map((result: any) => result[0])
          .map((result) => result.transcript)
          .join('');
        this.onSpeechDetected(text);
      });
      this.speechRecognition.addEventListener('end', (condition: any) => {
        if (this.isStoppedAutomatically) {
          this.speechRecognition.stop();
          this.speechRecognition.start();
          this.isStoppedAutomatically = true;
        }
      });
    } else {
    }
  }

  start(): boolean {
    if (this.speechRecognition) {
      if (!this.isStarted) {
        this.speechRecognition.start();
        this.isStarted = true;
      }
    }
    return true;
  }

  stop(): boolean {
    if (this.speechRecognition) {
      if (this.isStarted) {
        this.isStoppedAutomatically = false;
        this.speechRecognition.stop();
        this.isStarted = false;
      }
    }
    return false;
  }
}
